import React, {Component} from 'react'
import {default as DialogEl} from '@material-ui/core/Dialog/'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { ReactComponent as Close } from 'images/icons/close.svg'
import IconButton from '@material-ui/core/IconButton'

class Dialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
        this.handleClickOpen = this.handleClickOpen.bind(this)
    }

    componentDidMount() {
        this.setState({open: !!this.props.isOpen})
    }

    handleClickOpen() {
        this.props.clean && this.props.clean()
        this.props.createTicket && this.props.createTicket(false)
        this.props.resetInputs && this.props.resetInputs()
        this.setState(prevState => ({open: !prevState.open}))
    }

    render() {
        const {title, text, children, id, isOpen, width,onClose,hiddenClose, ...props} = this.props;
        const {open} = this.state
        return (<DialogEl
                classes={{paper: 'dialog_container'}}
                open={open}
                maxWidth={width ? width : 'sm'}
                fullWidth={true}
                keepMounted
                /*onClose={this.handleClickOpen}*/
                aria-labelledby={id}
                {...props}>
                {title && <DialogTitle classes={{root: 'dialog_title'}} id={id}>
                   <span>{title}</span>
                    {!hiddenClose && <IconButton aria-label="close" onClick={() => {
                        this.handleClickOpen()
                        onClose && onClose()
                    }}>
                        <Close/>
                    </IconButton>}
                </DialogTitle>}
                {title ? <DialogContent classes={{root: 'dialog_content'}}>
                    {text && <DialogContentText>
                        {text}
                    </DialogContentText>}
                    {children}
                </DialogContent> : children}
            </DialogEl>
        )
    }
}

export default Dialog